import axios from 'axios'

export default {
    namespaced: true,
    state: {
        emails: [],
        loadingEmails: false
    },

    getters: {
        emails: (state) => state.emails,
    },

    mutations: {
        SET_EMAILS(state, emails) {
            state.emails = emails;
        },

        CREATE_EMAIL(state, email) {
            state.emails.push(email);
        },

        SET_LOADING_EMAILS(state, loadingEmails) {
            state.loadingEmails = loadingEmails;
        },
    },

    actions: {
        loadEmails({ commit }, lead_id) {
            commit("SET_LOADING_EMAILS", true);

            axios.get(`/mail/${lead_id}/all`)
                .then(res => {
                    commit("SET_EMAILS", res.data.emails);
                    commit("SET_LOADING_EMAILS", false);
                })
                .catch(err => {
                    console.error(err);
                    commit("SET_LOADING_EMAILS", false);
                });
        },
    },

};
